import { reactive } from 'vue';

class FormErrors {
    /**
     * Create a new FormErrors instance.
     */
    constructor() {
        this.errors = reactive({});
    }

    /**
     * Determine if we have any errors.
     *
     * @return {boolean}
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Determine if an error exists for the given field.
     *
     * @param {String|Array} field
     * @return {boolean}
     */
    has(field) {
        if (typeof field === 'string') {
            return this.errors.hasOwnProperty(field);
        } else {
            for (let i in field) {
                if (this.errors.hasOwnProperty(field[i])) {
                    return true;
                }
            }

            return false;
        }
    }

    /**
     * Returns the error for the given field.
     *
     * @param {string} field
     * @return {string}
     */
    get(field, fullMessage) {
        if (this.has(field)) {
            if (fullMessage) {
                return this.errors[field];
            }

            if (Array.isArray(this.errors[field])) {
                return this.errors[field][0];
            } else {
                return this.errors[field];
            }
        }
    }

    /**
     * Record the new errors.
     *
     * @param {Object} errors
     */
    record(errors) {
        for (let key in errors) {
            const array = errors[key];

            if (Array.isArray(array)) {
                const isString = array.length ? typeof array[0] === 'string' : false;
                const isNumber = array.length ? typeof array[0] === 'number' : false;

                if (!isString && !isNumber) {
                    const object = errors[key].reduce((currentState, item) => {
                        return {
                            ...currentState,
                            ...item,
                        };
                    }, {});

                    for (let i in object) {
                        errors[`${key}.${i}`] = [object[i]];
                    }

                    delete errors[key];
                }
            }
        }

        Object.assign(this.errors, errors);
    }

    /**
     * Clear the given field, or all fields.
     *
     * @param {string=} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];
        } else {
            Object.keys(this.errors).forEach((key) => delete this.errors[key]);
        }
    }

    add(currentObj, field, value) {
        currentObj[field] = value;
    }
}

export default FormErrors;
